module.exports = __webpack_public_path__ + "69faab2434608e05f09f5219354c6382.jpg";